module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.414 28.586l-6.224-6.184c-.004-.004-.008-.004-.012-.008A13.91 13.91 0 0 0 28 14c0-7.718-6.282-14-14-14S0 6.282 0 14s6.282 14 14 14c3.15 0 6.05-1.058 8.392-2.82.004.004.004.008.008.012l6.186 6.222c.39.39.902.586 1.414.586s1.024-.196 1.414-.586a1.998 1.998 0 0 0 0-2.828zM20 15a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/magnifying-glass-3.js
// module id = 1250
// module chunks = 14